<div class="navigation">
  <a [routerLink]="[homeRoute]" style="text-decoration: none">
    <h3>AV.Park</h3>
  </a>
@if(envInfo){
  <div class="d-flex mb-3 center">
      <div class="navbar-brand" ngClass="{{envInfo}}">{{envInfo}}</div>
  </div>
}
  <div class="d-flex mb-3">

    <app-language-selector></app-language-selector>
    @if(authService.isUserLoggedIn()) {
      <button class="user-btn" ejs-dropdownbutton
          [items]="userNavigation"
          [content]="authService.getUserInfo() ? '\<span class=\'user-name\'>' + authService.getUserInfo().firstname + ' ' + authService.getUserInfo().lastname + '\</span>': ''"
          [iconCss]="userIcon"
          (select)="onSelection($event)"></button>
    }
  </div>
@if(authService.isUserLoggedIn()) {
  <ejs-accordion (created)="onAccordionCreated()" class="mb-3">
    <e-accordionitems>

      <e-accordionitem>
        <ng-template #header>
          <a [routerLinkActive]="['active']" [routerLink]="[homeRoute]">
            {{ 'i18n.core.navigation.home' | translate }}
          </a>
        </ng-template>
      </e-accordionitem>

      <e-accordionitem id="{{adminSectionId}}" [visible]="authService.isUserAdminOrClientAdminOrCompanyAdmin()">
        <ng-template #header>
          <div>{{ 'i18n.core.navigation.admin' | translate }}</div>
        </ng-template>
        <ng-template #content>
        @if(authService.isUserAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[clientAdministrationRoute]">
            {{ 'i18n.core.navigation.client-administration' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[userManagementRoute]">
            {{ 'i18n.core.navigation.user-management' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[configurationAdministrationRoute]">
            {{ 'i18n.core.navigation.configuration-administration' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[companyAdministrationRoute]">
            {{ 'i18n.core.navigation.company-administration' | translate }}
          </a>
        }
          <a [routerLinkActive]="['active']" [routerLink]="[parkerAdministrationRoute]">
            {{ 'i18n.core.navigation.parker-administration' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[fleetListAdministrationRoute]">
            {{ 'i18n.core.navigation.fleet-list' | translate }}
          </a>
          <a [routerLinkActive]="['active']" [routerLink]="[tagsAdministrationRoute]">
            {{ 'i18n.core.navigation.tags-administration' | translate }}
          </a>
        <!-- @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[onBoardingWizardRoute]">
            {{ 'i18n.core.navigation.onboarding-wizard' | translate }}
          </a>
        } -->
        @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[tagMasterRoute]">
            {{ 'i18n.core.navigation.tag-master' | translate }}
          </a>
        }
        @if(authService.isUserAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[thirdPartyUserZoneAssignmentAdministrationRoute]">
            {{ 'i18n.core.navigation.third-party-user-assignment-administration' | translate }}
          </a>
        }
        @if(authService.isUserAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[parkingRangerZoneAssignmentAdministrationRoute]">
            {{ 'i18n.core.navigation.parking-ranger-assignment-administration' | translate }}
          </a>
        }
        @if(authService.isUserAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[problemReportAdministrationRoute]">
            {{ 'i18n.core.navigation.problem-report-administration' | translate }}
          </a>
        }
        </ng-template>
      </e-accordionitem>

      <e-accordionitem id="{{parkingSectionId}}"
                       [visible]="authService.isUserAdminOrClientAdminOrCompanyAdmin() || authService.isUserStandardUser()">
        <ng-template #header>
          <div >{{ 'i18n.core.navigation.parking' | translate }}</div>
        </ng-template>
        <ng-template #content>
        @if(authService.isUserStandardUser() && hasActiveClient) {
          <a [routerLinkActive]="['active']" [routerLink]="[parkingRoute]">
            {{ 'i18n.core.navigation.parking' | translate }}
          </a>
        }
        @if(authService.isUserStandardUser() && hasActiveClient && hasAutomaticParking){
          <a [routerLinkActive]="['active']" [routerLink]="[automaticParkingRoute]">
            {{ 'i18n.core.navigation.automatic-parking' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdminOrCompanyAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[parkerRegistrationRoute]">
            {{ 'i18n.core.navigation.parker-registrations' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[parkingRangerSessionsRoute]">
            {{ 'i18n.core.navigation.parking-ranger-sessions' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[zoneDamageRoute]">
            {{ 'i18n.core.navigation.zone-damage' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[deviceInteraction]">
            {{ 'i18n.core.navigation.device-interaction' | translate }}
          </a>
        }
        @if(authService.isUserStandardUser()){
          <a [routerLinkActive]="['active']" [routerLink]="[parkingCardRoute]">
            {{ 'i18n.core.navigation.parking-card' | translate }}
          </a>
        }
        @if(authService.isUserAdminOrClientAdminOrCompanyAdmin()) {
          <a [routerLinkActive]="['active']" [routerLink]="[parkingCardAdminRoute]">
            {{ 'i18n.core.navigation.parking-card-admin' | translate }}
          </a>
        }
        </ng-template>
      </e-accordionitem>

      <e-accordionitem id="{{reportsSectionId}}">
        <ng-template #header>
          <div >{{ 'i18n.core.navigation.reports' | translate }}</div>
        </ng-template>
        <ng-template #content>
          <a [routerLinkActive]="['active']" [routerLink]="[savedReportsRoute]">
            {{ 'i18n.core.navigation.reports' | translate }}
          </a>
        @if(authService.isUserAdminOrClientAdminOrCompanyAdmin()){
          <a [routerLinkActive]="['active']" [routerLink]="[exportJobsRoute]">
            {{ 'i18n.core.navigation.export-jobs' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.TagsPerParker)){
          <a [routerLinkActive]="['active']" [routerLink]="[tagsPerParkerReportRoute]">
            {{ 'i18n.shared.reportTypes.TagsPerParker' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.ParkerRegistrations)){
          <a [routerLinkActive]="['active']" [routerLink]="[parkerRegistrationsReportRoute]">
            {{ 'i18n.shared.reportTypes.ParkerRegistrations' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.FalseRecordings)){
          <a [routerLinkActive]="['active']" [routerLink]="[falseRecordingsReportRoute]">
            {{ 'i18n.shared.reportTypes.FalseRecordings' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.ParkerTurnover)){
          <a [routerLinkActive]="['active']" [routerLink]="[parkerTurnoverReportRoute]">
            {{ 'i18n.shared.reportTypes.ParkerTurnover' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.ParkerExtract)){
          <a [routerLinkActive]="['active']" [routerLink]="[parkerExtractReportRoute]">
            {{ 'i18n.shared.reportTypes.ParkerExtract' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.DeviceStatus)){
          <a [routerLinkActive]="['active']" [routerLink]="[deviceStatusReportRoute]">
            {{ 'i18n.shared.reportTypes.DeviceStatus' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.AutomaticParking)){
          <a [routerLinkActive]="['active']" [routerLink]="[automaticParkingReportRoute]">
            {{ 'i18n.shared.reportTypes.AutomaticParking' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.Payment)){
          <a [routerLinkActive]="['active']" [routerLink]="[paymentReportRoute]">
            {{ 'i18n.shared.reportTypes.Payment' | translate }}
          </a>
        }
        @if(canUserSeeReport(ReportType.UserExtract)){
          <a [routerLinkActive]="['active']" [routerLink]="[userExtractReportRoute]">
            {{ 'i18n.shared.reportTypes.UserExtract' | translate }}
          </a>
        }
        </ng-template>
      </e-accordionitem>

    </e-accordionitems>
  </ejs-accordion>
}
  <div class="d-flex mb-3 center">
  @if(authService.isUserLoggedIn()) {
    <app-parking-indicator></app-parking-indicator>
  }
  </div>
</div>
